import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileuploaderComponent } from './fileuploader/fileuploader.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [FileuploaderComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule
  ],
  exports: [
    FileuploaderComponent
  ]
})
export class FileuploaderModule { }
